import { render, staticRenderFns } from "./PressTypeCreateEdit.vue?vue&type=template&id=702fbb12&scoped=true&"
import script from "./PressTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./PressTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./PressTypeCreateEdit.vue?vue&type=style&index=0&id=702fbb12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702fbb12",
  null
  
)

export default component.exports